export default __webpack_public_path__ + "static/media/specialityCategory.fc6b2e46.png";